import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  createTmpDownload: `${NAMESPACE}_CREATE_TMP_DOWNLOAD`,
  deleteTmpDownload: `${NAMESPACE}_DELETE_TMP_DOWNLOAD`,
  startDownload: `${NAMESPACE}_START_DOWNLOAD`,
  completedDownload: `${NAMESPACE}_COMPLETED_DOWNLOAD`,
  cancelDownload: `${NAMESPACE}_CANCEL_DOWNLOAD`,
  removeDownload: `${NAMESPACE}_REMOVE_DOWNLOAD`
};

export const actionCreators = {
  deleteTmpDownload: () => ({
    type: actions.deleteTmpDownload
  }),
  createTmpDownload: (payload) => ({
    type: actions.createTmpDownload,
    payload: payload
  }),
  startDownload: (downloadId) => ({
    type: actions.startDownload,
    payload: { downloadId }
  }),
  completedDownload: (downloadId, urlFile) => ({
    type: actions.completedDownload,
    payload: { downloadId, urlFile }
  }),
  cancelDownload: (downloadId) => ({
    type: actions.cancelDownload,
    payload: { downloadId }
  }),
  removeDownload: (downloadId) => ({
    type: actions.removeDownload,
    payload: { downloadId }
  })
};

export default {
  actions,
  actionCreators
};
